import { Component, Input, ViewEncapsulation } from '@angular/core';
import { DDatosCompartidosCabecera } from '@dian-cmp/formulario';


@Component({
  selector: 'app-cabecera-formulario',
  templateUrl: './cabecera-formulario.component.html',
  styleUrls: ['./cabecera-formulario.component.css'],
  encapsulation: ViewEncapsulation.None
})
export class CabeceraFormularioComponent {

  	@Input()
    dDatosCompartidosCabecera: DDatosCompartidosCabecera;

    /**
    * @constructor
    */
    constructor() {}    
    
    /**
    * @desc Funcion para redireccionar a la pagina del selector
    */
    private paginaSelector() {
        window.location.href = location.origin + '/WebDiligenciamiento/DefDiligenciamientoFormularios.faces';
    }

    /**
    * @desc Funcion para validar si el valor del periodo es NaN de lo contrario no retornar ningun valor
    * @param {Number} periodo
    * @return {String}
    */
    private verificarValorPeriodo(periodo:number): string|number {
        let valor = isNaN(periodo);
        return !valor ? periodo : 'Aperiodico';
    }
    // /**
    // * @desc Funcion para validar si el valor del periodo es NaN de lo contrario no retornar ningun valor
    // * @param {Number} periodo
    // * @return {String}
    // */
    // private verificarValorPeriodicidad(periodicidad:string): string|number {
    //     let valor = (periodicidad==undefined);
    //     return !valor ? periodicidad : 'Mensual';
    // }

}



// WEBPACK FOOTER //
// D:/github/490/rec_ng_recibopago490v7/src/app/components/formulario/cabecera-formulario/cabecera-formulario.component.ts